import React from 'react';
import {FormattedMessage} from "react-intl";
import {
    ImageFilenameTooltip,
    ImageNameTooltip,
    ImageSourceTooltip,
    ImageAltAttributeTooltip,
    ImageLinkTooltip
} from 'components/images/tooltips/image-edit-modal-tooltips';

let imageEditConfig = {
    fields: [
        {
            name: 'sponsoredType',
            type: 'hidden',
        },
        {
            name: 'filename',
            type: 'text-with-tooltip',
            required: true,

            props: {
                label: <FormattedMessage id='images.edit.filename' />,
                helpContent: <ImageFilenameTooltip />
            }
        },
        {
            name: 'name',
            type: 'text-with-tooltip',
            required: true,

            props: {
                label: <FormattedMessage id='images.edit.name' />,
                helpContent: <ImageNameTooltip />
            }
        },
        {
            name: 'source',
            type: 'text-with-tooltip',
            required: (proxy) => ( proxy.currentResource.sponsoredType === 'editorial' ),

            props: {
                label: <FormattedMessage id='images.edit.source' />,
                helpContent: <ImageSourceTooltip />
            }
        },
        {
            name: 'altAttribute',
            type: 'text-with-tooltip',
            required: false,

            props: {
                label: <FormattedMessage id='images.edit.altAttribute' />,
                helpContent: <ImageAltAttributeTooltip />
            }
        },
        {
            name: 'link',
            type: 'text-with-tooltip',

            props: {
                label: <FormattedMessage id='images.edit.link' />,
                helpContent: <ImageLinkTooltip />,

                validationRules: [
                    {
                        type: "HyperLinkFormat"
                    }
                ]
            }
        }
    ]
};

export default imageEditConfig;



// WEBPACK FOOTER //
// ./public/components/images/imageFormConfig.js